import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from "rxjs";
import {Apollo} from "apollo-angular";
import {ActivatedRoute, Router} from "@angular/router";
import {
  get_committee_dashboard_project,
  get_milestone_by_name
} from "../deals-committee-dashboard/graphql/getCommitteeDashboardProject";
import moment from "moment/moment";
import {formatCurrency} from "@angular/common";
import {DataFormatService} from "../../services/data-format.service";
import {
  CommitteeApprovalDashboardService
} from "../../committee-approval-dashboard/committee-approval-dashboard.service";
import {CommitteeItemsService} from "../../committee-approval-dashboard/committee-items/committee-items.service";
import {
  CommitteeApprovalsService
} from "../../committee-approval-dashboard/committee-approvals/committee-approvals.service";
import {EmbeddedReportService} from "../../components/embedded-report/embedded-report.service";
import Milestone from "../../interfaces/milestone";
import {CommitteeApprovalType} from "../../committee-approval-dashboard/committee-approvals/committee-approval-type";
import ProjectDisclosure from "../../interfaces/project-disclosure";
import CommitteeVote from "../../committee-approval-dashboard/committee-votes/committee-vote/committee-vote";

const GET_COMMITTEE_DASHBOARD_PROJECT = get_committee_dashboard_project;

@Component({
    selector: 'app-deals-closing-dashboard',
    templateUrl: './deals-closing-dashboard.component.html',
    styleUrls: ['./deals-closing-dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealsClosingDashboardComponent implements OnInit {

  info: any = [];
  doneDates: boolean = false;
  doneProj: boolean = false;
  project: any;
  isValidDate: boolean = false;
  formattedDate: string;
  querySubscription: Subscription;
  querySubscriptionProj: Subscription;
  datesData: any;
  doneLoading: boolean = false;
  // milestones: Milestone[] = []
  closingMilestone: Milestone
  capitalMilestone: Milestone
  readOnly: boolean = true;
  approvalTypes: CommitteeApprovalType[] = [];
  showReport = false;

  constructor(
    private apollo: Apollo,
    private dataFormat: DataFormatService,
    private dashboardService: CommitteeApprovalDashboardService,
    private route: ActivatedRoute,
    private router: Router,
    public itemsService: CommitteeItemsService,
    private approvalsService: CommitteeApprovalsService,
    public embeddedReportService: EmbeddedReportService
  ) {}
  @Input() projectid: string;

  ngOnInit(): void {
    const date = this.route.snapshot.paramMap.get('id');
    this.querySubscriptionProj = this.apollo
      .watchQuery<any>({
        query: GET_COMMITTEE_DASHBOARD_PROJECT,
        variables: {
          projectid: date,
          milestoneNames: [
            'Closed',
            'Capital Committee'
          ],
        },
      })
      .valueChanges.subscribe(({ data }) => {
        if(data){
          this.querySubscriptionProj.unsubscribe();
          if (data.milestones) {
            this.closingMilestone = data.milestones.find((milestone: Milestone) => milestone.name.toLowerCase() == 'closed')
            this.capitalMilestone = data.milestones.find((milestone: Milestone) => milestone.name.toLowerCase() == 'capital committee')
            this.closingMilestone = {
              committeeApprovalTypes: this.closingMilestone.committeeApprovalTypes,
              committeeVoteTypes: this.setVoteTypes(),
              id: this.closingMilestone.id,
              name: this.closingMilestone.name,
              __typename: 'Milestone'
            }
          }
          this.project = data.project;
          let closingVote = this.project.committeeVotes.find(
            (vote:CommitteeVote) => vote.committeeVoteType?.name.toLowerCase() === 'legal'
              && vote.milestone?.name.toLowerCase() === 'closed')?.status
          this.embeddedReportService.setFilters({ project_id: data.project.id });
          this.readOnly = closingVote !== undefined && closingVote !== null
          this.format();
          this.doneLoading = true;
          if (data.committeeApprovalTypes) {
            this.approvalTypes = data.committeeApprovalTypes;
            this.itemsService.approvalTypes = data.committeeApprovalTypes;
          }
        }
      });
  }
  ngOnDestroy() {
    this.querySubscriptionProj && this.querySubscriptionProj.unsubscribe();
    this.embeddedReportService.setShow(false);
  }
  state: string = 'default';

  recieveEditorHTML($event: ProjectDisclosure) {
    let index = this.info.disclosures.findIndex(
      (disclosure: ProjectDisclosure) =>
        disclosure.milestone_id === $event.milestone_id
    );
    if (index > -1) {
      this.info.disclosures[index] = $event;
    } else {
      this.info.disclosures.push($event);
    }
  }
  disclosureForMilestone(milestone: Milestone) {
    let dummyDisclosure = {
      id: 'new',
      project_id: this.project.id,
      disclosures: '',
      milestone_id: milestone.id,
      copy: '',
    };
    return (
      this.info.disclosures.find(
        (disclosure: ProjectDisclosure) =>
          disclosure.milestone_id === milestone.id
      ) || dummyDisclosure
    );
  }

  setVoteTypes(){
    let votingTypes = [];
    if(this.closingMilestone.committeeVoteTypes){
      for(let i = 0; i < this.closingMilestone.committeeVoteTypes.length; i++){
        votingTypes.push(this.closingMilestone.committeeVoteTypes[i])
      }

    }
    if(this.capitalMilestone.committeeVoteTypes){
      for(let g = 0; g < this.capitalMilestone.committeeVoteTypes.length; g++){
        votingTypes.push(this.capitalMilestone.committeeVoteTypes[g])
      }
    }
    return votingTypes
  }
  format() {
    let project: any = this.project;
    let temp: any;
    temp = {
      projectName: project.name,
      projectid: project.id,
      project: project,
      projecturl: this.dataFormat.formatLink(project),
      sharepointfolder: project.sharepoint_folder,
      islinked: project.is_synced_link,
      projectStatus: '',
      expand: true,
      info: [],
      creditTypes: [],
      creditOutlets: [],
      disclosures: [...project.projectDisclosures],
      committeeLinks: project.committeeLinks,
    };
    this.approvalsService.receiveCommitteeApprovals(
      project.id,
      project.committeeApprovals
    );
    if (project.projectStatuses !== null) {
      temp.projectStatus = project.projectStatuses[0].status.name;
    }

    //Closing Coordinator, Acquisition Analyst and Developer
    if (project.participants !== null) {
      if (
        this.dashboardService.getParticipant(
          project.participants,
          'Closing Coordinator'
        ) != null
      ) {
        temp.info.push(
          this.dashboardService.getParticipant(
            project.participants,
            'Closing Coordinator'
          )
        );
      }

      let acquisitionsAnalyst;
      if (
        (acquisitionsAnalyst = this.dashboardService.getParticipant(
          project.participants,
          'Acquisition Analyst'
        ))
      ) {
        temp.info.push(acquisitionsAnalyst);
      } else {
        temp.info.push({ key: 'Acquisitions Analyst', value: 'N/A' });
      }
      if (
        this.dashboardService.getParticipant(
          project.participants,
          'Sponsor'
        ) !== null
      ) {
        temp.info.push(
          this.dashboardService.getParticipant(
            project.participants,
            'Sponsor'
          )
        );
      } else {
        temp.info.push({ key: 'Sponsor', value: 'N/A' });
      }
      // if (
      //   this.dashboardService.getParticipant(
      //     project.participants,
      //     'Developer'
      //   ) !== null
      // ) {
      //   temp.info.push(
      //     this.dashboardService.getParticipant(
      //       project.participants,
      //       'Developer'
      //     )
      //   );
      // } else {
      //   temp.info.push({ key: 'Developer/Sponsor', value: 'N/A' });
      // }
    }

    //Closing Date
    if (project.pipelineProjects !== null) {
      let closing = null;
      for (let k = 0; k < project.pipelineProjects.length; k++) {
        if (
          project.pipelineProjects[0].closingDate !== null &&
          project.pipelineProjects[0].closingDate.length > 0
        ) {
          closing = moment
            .utc(project.pipelineProjects[0].closingDate[0].date)
            .format('MM/DD/YYYY');
          temp.info.push({ key: 'Closing Date', value: closing });
        }
      }
      if (closing === null) {
        temp.info.push({ key: 'Closing Date', value: 'N/A' });
      }
    }

    temp.info.push({key: 'Warehouse', value: this.dashboardService.getFundingSource(this.project.projectAttributes)})

    //Total Units

    // Account Manager
    if (
      this.dashboardService.getParticipant(
        project.participants,
        'Account Manager'
      ) !== null
    ) {
      temp.info.push(
        this.dashboardService.getParticipant(
          project.participants,
          'Account Manager'
        )
      );
    } else {
      temp.info.push({ key: 'Account Manager', value: 'N/A' });
    }

    //Credit Types and Credit Outlets
    let equity: number = 0;
    if (project.projectCredits !== null) {
      // temp.info.push({key: 'Credit Types', value: this.dataFormat.formatCreditTypes(project.projectCredits, false)});
      // temp.info.push({key: 'Credit Outlets', value: this.dataFormat.formatCreditOutlets(project.projectCredits)});
      temp.creditTypes = this.dataFormat.formatCreditTypes(
        project.projectCredits,
        false
      );
      temp.creditOutlets = this.dataFormat.formatCreditOutlets(
        project.projectCredits
      );

      for (let k = 0; k < project.projectCredits.length; k++) {
        if (project.projectCredits[k].equity_amount !== null) {
          equity += project.projectCredits[k].equity_amount;
        }
      }
    }

    //Originator
    if (
      project.participants !== null &&
      this.dashboardService.getParticipant(
        project.participants,
        'Originator'
      ) !== null
    ) {
      temp.info.push(
        this.dashboardService.getParticipant(project.participants, 'Originator')
      );
    }
    temp.info.push({
      key: 'Repeat Deal',
      value: project.is_repeat ? 'Yes' : 'No',
    });
    //LTEquity
    temp.info.push({
      key: 'LT Equity',
      value: formatCurrency(equity, 'en-US', '$', undefined, '1.0-0'),
    });

    if (!!project?.properties?.length) {
      temp.info.push({
        key: 'Total Units',
        value: project.properties[0].total_units,
      });
    }

    //City/State
    if (!!project?.properties[0]?.entity?.entityAddresses?.address?.zipCode) {
      temp.info.push({
        key: 'City/State',
        value:
          project.properties[0].entity.entityAddresses[0].address.zipCode.city +
          ', ' +
          project.properties[0].entity.entityAddresses[0].address.zipCode.state
            .abbreviation,
      });
    }
    let items = project.committeeItems.filter((item:any) => item.milestone_id == this.closingMilestone.id)
    this.itemsService.addItemsFromApi(project.id, items);
    this.info = temp;
  }
}
